<template>
<navBack></navBack>

 
  <div class="page">
    <div class="topBox">
      <div class="secondBar">
      <div class="sheetInfo">
          <t-button @click="choseDate(0)" size="extra-small" variant="text">{{ startDate }}</t-button>
          <t-icon name="arrow-down" color="gray" />
          <text class="txtSpan">至</text>
          <t-button @click="choseDate(1)" size="extra-small"  variant="text">{{ endDate }}</t-button>
          <t-icon name="arrow-down" size="42rpx" />
        </div>

        <div class="sheetInfo">


          <t-dropdown-menu >
            <t-dropdown-item :options="orderTypes" :value="typeIndex" @change="onOrderTypeChange" />
       
          </t-dropdown-menu>

 
        </div> 
      </div>
    </div> 

    <div v-if="orderList.length === 0&&isOver" class="emptyBox">
      <div class="imgBox">
        <image src="https://img01.yzcdn.cn/vant/empty-image-search.png" />
      </div>
      <div class="emptyInfo">暂无订单</div>
    </div>

    <div class="mainBox" @scroll="handleScroll">
      <orderItem v-for="(item, index) in orderList" :key="index" :order="item" @click="showOrder(item._id)" />
    </div>
  </div>

  <t-popup v-model="showDatePicker" placement="bottom">
    <t-date-time-picker :value="editDate"    :mode="['date']" title="选择时间" format="YYYY-MM-DD" @confirm="onDateConfirm"
      @cancel="showDatePicker = false" />
  </t-popup>


</template>

<script setup>
import { ref, onMounted, getCurrentInstance } from 'vue'
import dayjs from 'dayjs'
import { Toast } from 'tdesign-mobile-vue';
import { stateCustomer,stateShop } from '@/store';
import { useRouter} from "vue-router";
import navBack  from '@/components/nav-back.vue'
import orderItem from '@/components/order-item.vue'

 
const { proxy } = getCurrentInstance();

const app = proxy.$cloudbase; // Optional chaining to safely access $cloudbase

// 日期相关
const startDate = ref(dayjs().subtract(12, 'month').format('YYYY-MM-DD'));
const endDate = ref(dayjs().format('YYYY-MM-DD'));
const editDate = ref(dayjs().format('YYYY-MM-DD'));


const router = useRouter();



const orderList = ref([]);

const isOver = ref(false);

const pageIndex = ref(1);






const showDatePicker = ref(false);
const editDateType = ref(0);
// 订单类型相关
const typeIndex = ref(0);
 //const showTypePicker = ref(false);

const orderTypes = ref([
  { label: '全部', value: 0 },
  { label: '消费', value: 1 },
  { label: '充值', value: 2 },
  { label: '充次', value: 3 },
  { label: '打折卡', value: 4 },
  { label: '撤销订单', value: 5 }
]);
const choseDate = (type) => {
  showDatePicker.value = true;
  editDateType.value = type;
  editDate.value = type === 0 ? startDate.value : endDate.value;

}


// 日期选择器变更处理
const onDateConfirm = (e) => {
  if (editDateType.value === 0) {
    startDate.value = e;
  } else {
    endDate.value = e;
  }
  showDatePicker.value = false;
  loadOrderList()
}

const loadOrderList = async () => {
  if (isOver.value) {
    Toast('没有更多');

    return;
  }

  try {

    const db = app.database();
    const shopId = stateShop._id;
    // const customerId = customer_Id.value;

    const _ = db.command;
    let queryData = {
      'status': _.gt(0),
      shopId,
      'customer._id':stateCustomer._id,
    };

     queryData['createAt.time3'] = _.and(_.gte(startDate.value), _.lte(endDate.value));

    switch (typeIndex.value) {
      case 1:
        queryData['type'] = _.in([0,1,5]);
        break;
      case 2:
        queryData['type'] = 4;
        break;
      case 3:
        queryData['type'] = 2;
        break;
      case 4:
        queryData['type'] = 3;
        break;
      case 5:
        queryData['status'] = -1;
        break;
    }

    const _pageSize = 20;
    const _skipNum = Math.floor((pageIndex.value - 1) * _pageSize);

   

    const res = await db.collection("my_order")
      .where(queryData)
      .orderBy('createAt.timeStamp', 'desc')
      .skip(_skipNum)
      .limit(_pageSize)
      .get();

    if (res.data.length < _pageSize) {
      isOver.value = true;
    }
    pageIndex.value++;
    orderList.value = [...orderList.value, ...res.data];
  } catch (error) {


  console.log(error);

  }
}


// 类型选择器变更处理
// const onOrderTypeChange = (e) => {

//   typeIndex.value = e.value
//   loadOrderList()
// }

// 添加防抖标志，避免频繁触发加载
const isLoading = ref(false);

// 处理滚动事件，实现无限滚动加载
const handleScroll = async (e) => {
  // 如果正在加载或已经加载完所有数据，则直接返回
  if (isLoading.value || isOver.value) return;
  
  const { scrollTop, scrollHeight, clientHeight } = e.target;
  
  // 当滚动到底部附近时触发加载（距离底部50px）
  if (scrollHeight - scrollTop - clientHeight < 50) {
 
      await loadOrderList();
    
  }
}

// 显示订单详情
const showOrder = (id) => {
  // 跳转到订单详情页
  console.log('查看订单详情:', id)
  router.push({
    path: '/orderDetail',
    query: { id }
  })
}

// 加载订单列表


// 组件挂载时加载数据
onMounted(() => {
  loadOrderList()
})
</script>

<style scoped>
.page {
  background-color: #fff;
}

.topBox {
   padding:0 1vw;
   height:6vw;
background-color: #fff;
}

.secondBar {
  display: flex;
  justify-content: space-between;
}

.sheetInfo {
  display: flex;
  align-items: center;
 
  padding: 10rpx 20px;
  border-radius: 8px;
}

.picker {
  margin-right: 10px;
}

.txtSpan {
  margin: 0 10px;
}

.emptyBox {
  text-align: center;
  padding-top: 200px;
}

.imgBox image {
  width: 200px;
  height: 200px;
}

.emptyInfo {
  margin-top: 20px;
  color: #999;
}

.mainBox {
  margin-top: 30px;
 padding:2vw;
  display: flex;
  flex-direction: column;
  height: 90vh;
  align-items: center;
  flex: 1;

background-color: #f5f5f5;
  overflow-y: auto;
}
</style>